import { DefaultDocumentProgressFilter } from "../DocumentProgressFilter";

export interface DocumentProgressFilterType {
  option: DocumentProgressFilterOption
}

export interface DocumentProgressFilterOption {
  label: string
  value: server.dto.DocumentLifeCycleFilterOptions
}

export const DocumentProgressOptions: DocumentProgressFilterOption[] = [
  {
    label: RESX.DocumentLifeCycle.Draft,
    value: "draft"
  },
  {
    label: RESX.DocumentLifeCycle.Review,
    value: "review"
  },
  {
    label: RESX.DocumentLifeCycle.OutForSignature,
    value: "allPending"
  },
  {
    label: `${RESX.DocumentLifeCycle.OutForSignature} (${RESX.Financial.OverDue})`,
    value: "pendingOverdue"
  },
  {
    label: RESX.DocumentLifeCycle.Completed,
    value: "completed"
  },
  {
    label: RESX.DocumentLifeCycle.Discarded,
    value: "discarded"
  }
];

export const getOption = (value: server.dto.DocumentLifeCycleFilterOptions) => {
  return (
    DocumentProgressOptions.find((s) => s.value === value) ?? {
      label: "",
      value: "unknown"
    }
  );
};

export const initialDocumentProgressFilter: DocumentProgressFilterType = {
  option: getOption(DefaultDocumentProgressFilter)
};
